/**
 * Multi-column native scroll-snap carousel.
 * Loaded from sections/multi-column.liquid as type="module".
 */

const SELECTOR = '[data-section-type="multi-column"]'
const TRACK_CLASSES = [
  'multi-column__track--native',
  'flex',
  'gap-0',
  'overflow-x-auto',
  'scroll-smooth',
  'snap-x',
  'snap-mandatory',
  '[scrollbar-width:none]',
  '[-ms-overflow-style:none]',
  '[&::-webkit-scrollbar]:hidden',
]

function sliderEnabled(container) {
  const width = innerWidth
  if (width < 720) return container.dataset.sliderOnMobile === 'true'
  if (width < 960) return container.dataset.sliderOnTablet === 'true'
  return container.dataset.sliderOnDesktop === 'true'
}

function peekCount(raw, fallback) {
  const n = parseFloat(raw || fallback)
  return raw === '1' ? 1.4 : n * 1.1
}

function layout(container) {
  const { dataset } = container
  if (innerWidth < 720) {
    return {
      perView: parseFloat(dataset.mobileColumnsPerView || '2') * 1.1,
      gap: parseFloat(dataset.columnSpacingMobile || '12'),
    }
  }
  if (innerWidth < 960) {
    return {
      perView: peekCount(dataset.tabletColumnsPerView, '2'),
      gap: parseFloat(dataset.columnSpacingTablet || '12'),
    }
  }
  return {
    perView: peekCount(dataset.desktopColumnsPerView, '4'),
    gap: parseFloat(dataset.columnSpacingDesktop || '12'),
  }
}

function enableCarousel(track, slides, { perView, gap }) {
  track.classList.remove('grid')
  track.classList.add(...TRACK_CLASSES)
  track.style.gap = `${gap}px`

  const width = `calc((100% - ${(perView - 1) * gap}px) / ${perView})`
  for (const slide of slides) {
    slide.style.width = width
    slide.style.flexShrink = '0'
    slide.style.scrollSnapAlign = 'start'
  }
}

function disableCarousel(track, slides) {
  track.classList.remove(...TRACK_CLASSES)
  track.classList.add('grid')
  track.style.removeProperty('gap')
  for (const slide of slides) {
    slide.style.removeProperty('width')
    slide.style.removeProperty('flex-shrink')
    slide.style.removeProperty('scroll-snap-align')
  }
}

function sync(container) {
  const track = container.querySelector('[data-multi-column-track]')
  if (!track) return

  const slides = [...track.querySelectorAll('[data-multi-column-slide]')]
  if (!slides.length) return

  if (sliderEnabled(container)) enableCarousel(track, slides, layout(container))
  else disableCarousel(track, slides)
}

function init(container) {
  if (container.dataset.mcInit) return
  container.dataset.mcInit = 'true'
  sync(container)
}

function initAll(root = document) {
  root.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
addEventListener('resize', () => {
  document.querySelectorAll(`${SELECTOR}[data-mc-init]`).forEach(sync)
})

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target)
})
